import { createContext } from 'react'

export const DeviceUserContext = createContext()
